<div class="status" [ngClass]="textClass">
  <i
    [ngClass]="faIconClass"
    class="status-i"
    role="img"
    [attr.aria-label]="statusText | translate"
    [attr.title]="statusText | translate"
  ></i>
  <span class="status-text">{{ statusText | translate }}</span>
  @if (errorMessage) {
    <span class="visually-hidden">{{ errorMessage | translate }}</span>
  }
</div>
